import React from 'react';
import ProtectedRoute from './ProtectedRoute';
import PlatformMfaGate from './Security/PlatformMfaGate';

/**
 * /monitoring: mismo acceso que antes (rol admin, ProtectedRoute allowedRoles=['admin']; DA-019, no se quita a nadie).
 * Ademas, el staff de plataforma (verificado o con 2FA pendiente) pasa por PlatformMfaGate: enrolar / verificar y luego
 * la pantalla. Para quien no es staff el Gate deja pasar sin pedir nada. La autorizacion real la hace el backend.
 */
export default function MonitoringRoute({ children }: { children: React.ReactNode }) {
  return (
    <ProtectedRoute allowedRoles={['admin']}>
      <PlatformMfaGate>{children}</PlatformMfaGate>
    </ProtectedRoute>
  );
}
